import React, { useState } from "react";
import { useNavigate,Link } from "react-router-dom"; // Import for routing
import { FaPhoneAlt, FaSearch, FaCheck, FaArrowRight } from "react-icons/fa";
import "../Css/BabyCare.css";
import BabyCareImage from "../assets/service-2.jpg";




const BabyCare = () => {

    const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  // List of your services
  const services = [
  { name: "Patient Care", path: "/services/patient-care-service-in-mumbai" },
  { name: "Baby Care", path: "/services/baby-care-service-in-mumbai" },
  { name: "House Maid", path: "/services/house-maid-service-in-mumbai" },
  { name: "Cooking", path: "/services/cooking-service-in-mumbai" },
  { name: "Driver", path: "/services/driver-service-in-mumbai" },
  { name: "Home Cleaning", path: "/services/home-cleaning-service-in-mumbai" },
  { name: "Japa Maid", path: "/services/japa-maid-service-in-mumbai" },
];

  // Filter logic
  const filteredServices = services.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  
  return (
    <div className="BabyCare-page">
      {/* HERO SECTION - RETAINED AS REQUESTED */}
      <section className="BabyCare-hero">
        <div className="BabyCare-overlay">
          <div className="BabyCare-hero-content">
            <h1>Baby Care</h1>
            <p>
              <span><a href="/">Home</a></span> / <span className="active">Baby Care</span>
            </p>
          </div>
        </div>
      </section>

      {/* SQUARE PREMIUM CONTENT */}
      <section className="main-section">
        <div className="container-square">
          <div className="content-layout">
            
            {/* Main Content Area */}
            <div className="article-box">
              <div className="square-img-holder">
                <img src={BabyCareImage} alt="Baby Care Services" />
                <div className="img-overlay-label">PREMIUM SERVICE</div>
              </div>

              <div className="text-header">
                <h2 className="title-bold">Baby Sitter Service Agency in Mumbai</h2>
                <h4 className="subtitle-line">Experienced Babysitter Agency in Mumbai</h4>
              </div>

              <div className="body-description">
                <p>SVK Maid Service is a trusted provider of Babysitter Services Mumbai, dedicated to offering reliable, professional, and nurturing child care solutions. We understand that parents need peace of mind while managing their busy lives, and our experienced nannies ensure your children are safe, happy, and well-cared for.</p>
                <p>Our team specializes in helping families Hire Nanny Mumbai with verified backgrounds and professional training. Each nanny is skilled in child care, educational support, and emotional guidance, making your child’s home environment safe and engaging.</p>
                
              </div>

              {/* Why Choose - Modern Square Grid */}
              <div className="why-choose-square">
                <h3>Why Choose SVK Maid Service for Babysitter Services?</h3>
                <div className="grid-features">
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Skilled Babysitters:</strong> Trained in child care, feeding, hygiene, homework assistance, and emotional support.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Verified & Trustworthy:</strong> All nannies are thoroughly background-checked and professional.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Flexible Services:</strong> Options for full-time, part-time, or hourly child care based on your household needs.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Child Care Services Mumbai:</strong> Comprehensive care for children, ensuring safety, growth, and emotional development.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Personalized Matching:</strong> We assign nannies according to your child’s age, needs, and family preferences.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Dedicated Support:</strong> Our customer service team ensures seamless communication and smooth service experience.</p>
                  </div>
                </div>
              </div>

              <div className="summary-footer-box">
                <p>If you want to Hire Nanny Mumbai, SVK Maid Service makes the process easy and stress-free. Our nannies are trained to provide a safe and engaging environment, help with educational activities, and encourage good habits. We focus on creating a nurturing atmosphere that promotes both learning and emotional well-being for your child.</p>
              </div>
              <div className="summary-footer-box">
                <p>By choosing SVK Maid Service, you are opting for the most reliable and professional Babysitter Services Mumbai in the city. Our caregivers ensure that your children receive attentive, compassionate, and professional care, allowing parents to focus on work or personal commitments without worry.</p>
              </div>
              <div className="summary-footer-box">
                <p>Experience the difference with SVK Maid Service, a trusted partner for families seeking dependable, skilled, and loving child care. Let our expert nannies provide the care your child deserves, making your home a safe and happy place.</p>
              </div>
            </div>

            {/* Square Sidebar */}
            <aside className="sidebar-square">
              {/* ACTIVE SEARCH BOX */}
      <div className="search-container-premium">
        <div className="search-square">
          <input
            type="text"
            placeholder="SEARCH SERVICES..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button><FaSearch /></button>
        </div>

        {/* Search Results Dropdown */}
        {searchTerm && (
          <div className="search-results-dropdown">
            {filteredServices.length > 0 ? (
              filteredServices.map((service, index) => (
                <div
                  key={index}
                  className="result-item"
                  onClick={() => navigate(service.path)}
                >
                  {service.name}
                </div>
              ))
            ) : (
              <div className="no-result">No services found</div>
            )}
          </div>
        )}
      </div>

              <div className="list-widget">
                <h5>OUR SERVICES</h5>
                <ul className="square-links">
  <li>
    <Link to="/services/patient-care-service-in-mumbai">
      Patient Care <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link
      to="/services/baby-care-service-in-mumbai"
      className="active-item"
    >
      Baby Care <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/house-maid-service-in-mumbai">
      House Maid <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/cooking-service-in-mumbai">
      Cooking <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/driver-service-in-mumbai">
      Driver <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/home-cleaning-service-in-mumbai">
      Home Cleaning <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/japa-maid-service-in-mumbai">
      Japa Maid <FaArrowRight />
    </Link>
  </li>
</ul>
              </div>

<div className="contact-box-square">
  <div className="cta-overlay-square">
    <div className="cta-icon-square">
      <FaPhoneAlt />
    </div>
    <h3 className="cta-title-square">Call us Today!</h3>
    <a href="tel:+919152151180" className="cta-phone-square">
      +91 91521 51180
    </a>
    <a href="mailto:info@svkmaidservice.com" className="cta-email-square">
      info@svkmaidservice.com
    </a>
  </div>
</div>
            </aside>

          </div>
        </div>
      </section>
    </div>
  );
};

export default BabyCare;